// The project's Runs, Reports and Knowledge sections (/p/:key/runs, /reports,
// /knowledge): the existing pages and tabs, scoped to the project.

import { RequireProject } from '../../lib/project-context'
import { PageHeader } from '../../components/ui'
import { ProjectReportsTab } from '../../components/reports/project-reports'
import { AgentsPage } from '../agents'
import { RunsListPage } from '../runs/index'
import { ProjectKnowledgeTab } from '../projects'

export function ProjectAgentsPage() {
  return <RequireProject>{(project) => <AgentsPage key={project.id} projectId={project.id} />}</RequireProject>
}

export function ProjectRunsPage() {
  return <RequireProject>{(project) => <RunsListPage key={project.id} projectId={project.id} />}</RequireProject>
}

export function ProjectReportsPage() {
  return (
    <RequireProject>
      {(project) => (
        <div>
          <PageHeader title="Reports" description={`Task reports of ${project.name}.`} />
          <ProjectReportsTab projectId={project.id} />
        </div>
      )}
    </RequireProject>
  )
}

export function ProjectKnowledgePage() {
  return (
    <RequireProject>
      {(project) => (
        <div>
          <PageHeader
            title="Knowledge"
            description={`What agents know about ${project.name}.`}
          />
          <ProjectKnowledgeTab key={project.id} project={project} />
        </div>
      )}
    </RequireProject>
  )
}
